import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class AccordionOld extends ThemeComponent {

    init() {
        const triggers = this.querySelectorAll('h4');

        for (const accordionTrigger of triggers) {

            this.$listen(accordionTrigger, 'click', (event) => {
                this.onAccordionTriggerClick(event);
            });
        }
    }

    onAccordionTriggerClick(event: Event) {
        if (!event.currentTarget) {return;}
        const thisTarget = event.currentTarget as HTMLHeadingElement;
        if (!thisTarget) {return;}

        thisTarget.classList.toggle('active-header');
        const hiddenElement = thisTarget.nextElementSibling as HTMLUListElement;
        if (!hiddenElement) {return;}

        hiddenElement.classList.toggle('showing-content');
    }
}
